import React from 'react';
import './index.less';

import TablePropTypes from '../../prop-types';

import TableBodyItem from '../TableBodyItem';

function TableBody({ columns, renderTD, rows, payload }) {
	return (
		<tbody className='new-table__body'>
			{rows.map((row) => (
				<TableBodyItem
					columns={columns}
					renderTD={renderTD}
					row={row}
					payload={payload}
					key={String(row.id)}
				/>
			))}
		</tbody>
	);
}

TableBody.propTypes = {
	columns: TablePropTypes.ColumnsPropType,
	renderTD: TablePropTypes.RenderPropType,
	rows: TablePropTypes.RowsPropType,
	payload: TablePropTypes.PayloadPropType
};

export default TableBody;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/new-table/components/TableBody/index.js